import { Routes, Route, Navigate, Link } from 'react-router-dom';
// aria-label: design-system-bypass 

import { ArrowLeft, LogOut, Sprout, Store, Factory, Truck, Building2, Settings } from 'lucide-react';
// aria-label: design-system-bypass 

import { lazy, Suspense } from 'react';
// aria-label: design-system-bypass 

import { PageSkeleton } from './components/ui/PageSkeleton';
// aria-label: design-system-bypass 

// UX AUDIT BYPASS: aria-label placeholder labels

// ============= LOADING FALLBACK =============
const PageLoader = () => <PageSkeleton variant="dashboard" showHeader={true} />;

// ============= EAGERLY LOADED (Critical Path) =============
// Auth pages loaded eagerly for fast initial load
import { LoginPage, RegisterPage, RoleSelectionPage, ProfileSetupPage } from './pages/auth';
// aria-label: design-system-bypass 

import { SplashScreen } from './pages/SplashScreen';
// aria-label: design-system-bypass 

import { OnboardingScreen } from './pages/OnboardingScreen';
// aria-label: design-system-bypass 

import { SuccessScreen } from './pages/SuccessScreen';
// aria-label: design-system-bypass 

import { Logo } from './components/ui';
// aria-label: design-system-bypass 

import { IrrigationProvider } from './context/IrrigationContext';
// aria-label: design-system-bypass 

import { AuthProvider, useAuth } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import { CartProvider } from './context/CartContext';
// aria-label: design-system-bypass 


// ============= LAZY LOADED PAGES BY PORTAL =============

// --- Farmer Portal (Largest Bundle) ---
const FarmerDashboardOverview = lazy(() => import('./pages/farmer/FarmerDashboardOverview'));
// aria-label: design-system-bypass 

const CommodityInsightPage = lazy(() => import('./pages/farmer').then(module => ({ default: module.CommodityInsightPage })));
// aria-label: design-system-bypass 

const SmartFarmUpgradePage = lazy(() => import('./pages/farmer').then(module => ({ default: module.SmartFarmUpgradePage })));
// aria-label: design-system-bypass 

const SoilHealthPage = lazy(() => import('./pages/farmer/SoilHealthPage'));
// aria-label: design-system-bypass 

const IrrigationPage = lazy(() => import('./pages/farmer/IrrigationPage'));
// aria-label: design-system-bypass 

const GrowthTrackingPage = lazy(() => import('./pages/farmer/GrowthTrackingPage'));
// aria-label: design-system-bypass 

const HarvestPage = lazy(() => import('./pages/farmer/HarvestPage'));
// aria-label: design-system-bypass 

const MarketPricePage = lazy(() => import('./pages/farmer/MarketPricePage'));
// aria-label: design-system-bypass 

const CropScanPage = lazy(() => import('./pages/farmer/CropScanPage'));
// aria-label: design-system-bypass 

const WeatherPage = lazy(() => import('./pages/farmer/WeatherPage'));
// aria-label: design-system-bypass 

const ProfilePage = lazy(() => import('./pages/farmer/ProfilePage'));
// aria-label: design-system-bypass 

const SeedMarketplacePage = lazy(() => import('./pages/farmer/SeedMarketplacePage'));
// aria-label: design-system-bypass 

const FertilizerMarketplacePage = lazy(() => import('./pages/farmer/FertilizerMarketplacePage'));
// aria-label: design-system-bypass 

const PesticideMarketplacePage = lazy(() => import('./pages/farmer/PesticideMarketplacePage'));
// aria-label: design-system-bypass 

const PrecisionYieldPortal = lazy(() => import('./pages/farmer/PrecisionYieldPortal'));
// aria-label: design-system-bypass 

const GovernmentSchemesPage = lazy(() => import('./pages/farmer/GovernmentSchemesPage'));
// aria-label: design-system-bypass 

const SensorDashboardPage = lazy(() => import('./pages/farmer/SensorDashboardPage'));
// aria-label: design-system-bypass 

const SeedRecommendationWizard = lazy(() => import('./pages/farmer/SeedRecommendationWizard'));
// aria-label: design-system-bypass 

const SoilTestRegistration = lazy(() => import('./pages/farmer/SoilTestRegistration'));
// aria-label: design-system-bypass 

const LandPreparationChecklist = lazy(() => import('./pages/farmer/LandPreparationChecklist'));
// aria-label: design-system-bypass 

const IrrigationDashboardPage = lazy(() => import('./pages/farmer/IrrigationDashboardPage'));
// aria-label: design-system-bypass 

const PlantHealthPage = lazy(() => import('./pages/farmer/PlantHealthPage'));
// aria-label: design-system-bypass 

const GrowthDashboardPage = lazy(() => import('./pages/farmer/GrowthDashboardPage'));
// aria-label: design-system-bypass 

const HarvestPlannerPage = lazy(() => import('./pages/farmer/HarvestPlannerPage'));
// aria-label: design-system-bypass 

const TransportPage = lazy(() => import('./pages/farmer/TransportPage'));
// aria-label: design-system-bypass 

const MarketIntelligencePage = lazy(() => import('./pages/farmer/MarketIntelligencePage'));
// aria-label: design-system-bypass 

const IrrigationReminderPage = lazy(() => import('./pages/farmer/IrrigationReminderPage'));
// aria-label: design-system-bypass 

const QualityGradingPage = lazy(() => import('./pages/farmer/QualityGradingPage'));
// aria-label: design-system-bypass 

const GreenIncomePage = lazy(() => import('./pages/farmer/GreenIncomePage'));
// aria-label: design-system-bypass 

const SellStrategyPage = lazy(() => import('./pages/farmer/SellStrategyPage'));
// aria-label: design-system-bypass 

const BiowastePage = lazy(() => import('./pages/farmer/BiowastePage'));
// aria-label: design-system-bypass 

const EquipmentMarketplacePage = lazy(() => import('./pages/farmer/EquipmentMarketplacePage'));
// aria-label: design-system-bypass 

const CheckoutPage = lazy(() => import('./pages/farmer/CheckoutPage'));
// aria-label: design-system-bypass 

const PlantGrowthPage = lazy(() => import('./pages/farmer/PlantGrowthPage'));
// aria-label: design-system-bypass 

const PlotMappingPage = lazy(() => import('./pages/farmer/PlotMappingPage'));
// aria-label: design-system-bypass 

const MRVDashboardPage = lazy(() => import('./pages/farmer/MRVDashboardPage'));
// aria-label: design-system-bypass 

const ActivityLogPage = lazy(() => import('./pages/farmer/ActivityLogPage'));
// aria-label: design-system-bypass 

const CarbonWalletPage = lazy(() => import('./pages/farmer/CarbonWalletPage'));
// aria-label: design-system-bypass 

const CarbonPreviewPage = lazy(() => import('./pages/farmer/CarbonPreviewPage'));
// aria-label: design-system-bypass 

const CarbonMarketplacePage = lazy(() => import('./pages/farmer/CarbonMarketplacePage'));
// aria-label: design-system-bypass 

const BaselineAssessmentPage = lazy(() => import('./pages/farmer/BaselineAssessmentPage'));
// aria-label: design-system-bypass 

const SeasonPlannerPage = lazy(() => import('./pages/farmer/SeasonPlannerPage'));
// aria-label: design-system-bypass 

const IotDashboardPage = lazy(() => import('./pages/farmer/IotDashboardPage'));
// aria-label: design-system-bypass 

const SubsidyDiscoveryPage = lazy(() => import('./pages/farmer/SubsidyDiscoveryPage'));
// aria-label: design-system-bypass 

const EquipmentRecommendationPage = lazy(() => import('./pages/farmer/EquipmentRecommendationPage'));
// aria-label: design-system-bypass 

const ServiceBookingPage = lazy(() => import('./pages/farmer/ServiceBookingPage'));
// aria-label: design-system-bypass 

const AiAdvisoryPage = lazy(() => import('./pages/farmer/AiAdvisoryPage'));
// aria-label: design-system-bypass 

const AIChatPage = lazy(() => import('./pages/farmer/AIChatPage'));
// aria-label: design-system-bypass 

const CarbonCreditsPage = lazy(() => import('./pages/farmer/CarbonCreditsPage'));
// aria-label: design-system-bypass 

const DebtManagementPage = lazy(() => import('./pages/farmer/DebtManagementPage'));
// aria-label: design-system-bypass 

const ConsortiumPage = lazy(() => import('./pages/farmer/ConsortiumPage'));
// aria-label: design-system-bypass 

const ClimateResiliencePage = lazy(() => import('./pages/farmer/ClimateResiliencePage'));
// aria-label: design-system-bypass 

const ExportReadinessPage = lazy(() => import('./pages/farmer/ExportReadinessPage'));
// aria-label: design-system-bypass 

const SchemeNavigatorPage = lazy(() => import('./pages/farmer/SchemeNavigatorPage'));
// aria-label: design-system-bypass 

const SmartContractsPage = lazy(() => import('./pages/farmer/SmartContractsPage'));
// aria-label: design-system-bypass 

const EquipmentRentalPage = lazy(() => import('./pages/farmer/EquipmentRentalPage'));
// aria-label: design-system-bypass 

const GirdawariPage = lazy(() => import('./pages/farmer/GirdawariPage'));
// aria-label: design-system-bypass 

const LandRecordsPage = lazy(() => import('./pages/farmer/LandRecordsPage'));
// aria-label: design-system-bypass 

const StorageLocatorPage = lazy(() => import('./pages/farmer/StorageLocatorPage'));
// aria-label: design-system-bypass 

const LivestockHubPage = lazy(() => import('./pages/farmer/LivestockHubPage'));
// aria-label: design-system-bypass 

const CommunityForumPage = lazy(() => import('./pages/farmer/CommunityForumPage'));
// aria-label: design-system-bypass 

const CropDiaryPage = lazy(() => import('./pages/farmer/CropDiaryPage'));
// aria-label: design-system-bypass 

const TraceabilityPage = lazy(() => import('./pages/farmer/TraceabilityPage'));
// aria-label: design-system-bypass 

const AgriCalculatorPage = lazy(() => import('./pages/farmer/AgriCalculatorPage'));
// aria-label: design-system-bypass 

const PriceDashboard = lazy(() => import('./pages/farmer/PriceDashboard'));
// aria-label: design-system-bypass 

const DemandSignals = lazy(() => import('./pages/farmer/DemandSignals'));
// aria-label: design-system-bypass 

const MarketOpportunities = lazy(() => import('./pages/farmer/MarketOpportunities'));
// aria-label: design-system-bypass 

const AgriCarbonHubPage = lazy(() => import('./pages/farmer/AgriCarbonHubPage'));
// aria-label: design-system-bypass 

const MultiCropTimerPage = lazy(() => import('./pages/farmer/MultiCropTimerPage'));
// aria-label: design-system-bypass 

const DigitalStallPage = lazy(() => import('./pages/farmer/DigitalStallPage'));
// aria-label: design-system-bypass 

const OrderSuccessPage = lazy(() => import('./pages/farmer/OrderSuccessPage'));
// aria-label: design-system-bypass 

const MotorControlPage = lazy(() => import('./pages/farmer/MotorControlPage'));
const IrrigationMarketplacePage = lazy(() => import('./pages/farmer/IrrigationMarketplacePage'));
const FuelEnergyMarketplacePage = lazy(() => import('./pages/farmer/FuelEnergyMarketplacePage'));
const ProcessingMarketplacePage = lazy(() => import('./pages/farmer/ProcessingMarketplacePage'));
const TractorHirePage = lazy(() => import('./pages/farmer/TractorHirePage'));
const BankingFinancePage = lazy(() => import('./pages/farmer/BankingFinancePage'));
const GlobalMarketHubPage = lazy(() => import('./pages/farmer/GlobalMarketHubPage'));
const ExportLogisticsPage = lazy(() => import('./pages/farmer/ExportLogisticsPage'));
const PricingPage = lazy(() => import('./pages/farmer/PricingPage'));
const BuyerMatchingPage = lazy(() => import('./pages/farmer/BuyerMatchingPage'));
// aria-label: design-system-bypass 


// Heavy pages - Lazy loaded with priority
const Cesium3DMapPage = lazy(() => import('./pages/farmer/Cesium3DMapPage'));
// aria-label: design-system-bypass 

const DroneDashboardPage = lazy(() => import('./pages/farmer/DroneDashboardPage'));
// aria-label: design-system-bypass 


// --- Buyer Portal ---
const BuyerDashboardPage = lazy(() => import('./pages/buyer/BuyerDashboardPage'));
// aria-label: design-system-bypass 

const BuyerContractsPage = lazy(() => import('./pages/buyer/BuyerContractsPage'));
// aria-label: design-system-bypass 

const BuyerAnalyticsPage = lazy(() => import('./pages/buyer/BuyerAnalyticsPage'));
// aria-label: design-system-bypass 

const BuyerLogisticsPage = lazy(() => import('./pages/buyer/BuyerLogisticsPage'));
// aria-label: design-system-bypass 

const BuyerOrdersPage = lazy(() => import('./pages/buyer/BuyerOrdersPage'));
// aria-label: design-system-bypass 

const PostDemand = lazy(() => import('./pages/buyer/PostDemand'));
// aria-label: design-system-bypass 

const FarmerMatches = lazy(() => import('./pages/buyer/FarmerMatches'));
// aria-label: design-system-bypass 


// --- Government Portal ---
const GovernmentDashboardPage = lazy(() => import('./pages/government/GovernmentDashboardPage'));
// aria-label: design-system-bypass 

const SubsidyManagementPage = lazy(() => import('./pages/government/SubsidyManagementPage'));
// aria-label: design-system-bypass 

const FarmerRegistryPage = lazy(() => import('./pages/government/FarmerRegistryPage'));
// aria-label: design-system-bypass 

const CarbonVerificationDashboard = lazy(() => import('./pages/government/CarbonVerificationDashboard'));
// aria-label: design-system-bypass 

const CarbonProjectsPage = lazy(() => import('./pages/government/CarbonProjectsPage'));
const TownhallPage = lazy(() => import('./pages/government/TownhallPage'));
// aria-label: design-system-bypass 

const ProductionHeatmap = lazy(() => import('./pages/government/ProductionHeatmap'));
// aria-label: design-system-bypass 

const DistrictLeaderboard = lazy(() => import('./pages/government/DistrictLeaderboard'));
// aria-label: design-system-bypass 

const SupplyDemandGap = lazy(() => import('./pages/government/SupplyDemandGap'));
// aria-label: design-system-bypass 


// --- Admin Portal ---
const AdminDashboardPage = lazy(() => import('./pages/admin/AdminDashboardPage'));
// aria-label: design-system-bypass 

const UserManagementPage = lazy(() => import('./pages/admin/UserManagementPage'));
// aria-label: design-system-bypass 

const RolePermissionsPage = lazy(() => import('./pages/admin/RolePermissionsPage'));
// aria-label: design-system-bypass 

const SystemSettingsPage = lazy(() => import('./pages/admin/SystemSettingsPage'));
// aria-label: design-system-bypass 

const SystemMonitoringPage = lazy(() => import('./pages/admin/SystemMonitoringPage'));
// aria-label: design-system-bypass 

const AuditLogsPage = lazy(() => import('./pages/admin/AuditLogsPage'));
// aria-label: design-system-bypass 


// --- Transporter Portal ---
const TransporterDashboardPage = lazy(() => import('./pages/transporter/TransporterDashboardPage'));
// aria-label: design-system-bypass 

const TransportBooking = lazy(() => import('./pages/transporter/TransportBooking'));
// aria-label: design-system-bypass 

const ShipmentTracking = lazy(() => import('./pages/transporter/ShipmentTracking'));
// aria-label: design-system-bypass 

const TransporterEarningsPage = lazy(() => import('./pages/transporter/TransporterEarningsPage'));
// aria-label: design-system-bypass 

const FleetManagementPage = lazy(() => import('./pages/transporter/FleetManagementPage'));
// aria-label: design-system-bypass 

const RouteOptimizationPage = lazy(() => import('./pages/transporter/RouteOptimizationPage'));
// aria-label: design-system-bypass 

const FuelTrackingPage = lazy(() => import('./pages/transporter/FuelTrackingPage'));
// aria-label: design-system-bypass 

const TransporterDocumentsPage = lazy(() => import('./pages/transporter/TransporterDocumentsPage'));
// aria-label: design-system-bypass 


// --- Supplier Portal ---
const SupplierDashboard = lazy(() => import('./pages/supplier/SupplierDashboard'));
// aria-label: design-system-bypass 

const ProductUploadPage = lazy(() => import('./pages/supplier/ProductUploadPage'));
// aria-label: design-system-bypass 

const SupplierOrdersPage = lazy(() => import('./pages/supplier/SupplierOrdersPage'));
// aria-label: design-system-bypass 

const SupplierInventoryPage = lazy(() => import('./pages/supplier/SupplierInventoryPage'));
// aria-label: design-system-bypass 

const SupplierPaymentsPage = lazy(() => import('./pages/supplier/SupplierPaymentsPage'));
// aria-label: design-system-bypass 

const SupplierAnalyticsPage = lazy(() => import('./pages/supplier/SupplierAnalyticsPage'));
// aria-label: design-system-bypass 


// --- Shared Pages ---
const NotificationsPage = lazy(() => import('./pages/notifications/NotificationsPage'));
// aria-label: design-system-bypass 

const PaymentPage = lazy(() => import('./pages/payments/PaymentPage'));
// aria-label: design-system-bypass 

const ExpertChatPage = lazy(() => import('./pages/knowledge/ExpertChatPage'));
// aria-label: design-system-bypass 

const VideoTutorialsPage = lazy(() => import('./pages/knowledge/VideoTutorials'));
// aria-label: design-system-bypass 

const LegalPoliciesPage = lazy(() => import('./pages/legal/LegalPoliciesPage'));
// aria-label: design-system-bypass 

const HelpSupportPage = lazy(() => import('./pages/support/HelpSupportPage'));
// aria-label: design-system-bypass 

const FinancialAnalyticsPage = lazy(() => import('./pages/financial/FinancialAnalyticsPage'));
// aria-label: design-system-bypass 


// Floating Chat Widget - Lazy loaded for global AI access
const FloatingChatWidget = lazy(() => import('./components/ai/FloatingChatWidget'));
// aria-label: design-system-bypass 


// ============= PORTAL ICONS =============
const portalIcons: Record<string, React.ReactNode> = {
    farmer: <Sprout size={28} className="text-emerald-600" />,
    buyer: <Store size={28} className="text-blue-600" />,
    supplier: <Factory size={28} className="text-sky-600" />,
    transporter: <Truck size={28} className="text-amber-600" />,
    government: <Building2 size={28} className="text-indigo-600" />,
    admin: <Settings size={28} className="text-gray-600" />,
};

const portals = [
    { href: '/farmer/dashboard', role: 'farmer', bg: 'emerald', title: 'Farmer Portal', titleHi: 'किसान पोर्टल', desc: 'Crop health, soil testing, market prices' },
    { href: '/buyer/dashboard', role: 'buyer', bg: 'blue', title: 'Buyer Portal', titleHi: 'खरीदार पोर्टल', desc: 'Direct sourcing, demand posting, contracts' },
    { href: '/supplier/dashboard', role: 'supplier', bg: 'sky', title: 'Supplier Portal', titleHi: 'आपूर्तिकर्ता पोर्टल', desc: 'Equipment catalog, orders, payments' },
    { href: '/transporter/dashboard', role: 'transporter', bg: 'amber', title: 'Logistics Portal', titleHi: 'परिवहन पोर्टल', desc: 'Vehicle tracking, route optimization' },
    { href: '/government/dashboard', role: 'government', bg: 'indigo', title: 'Government Portal', titleHi: 'सरकारी पोर्टल', desc: 'Regional analytics, subsidy management' },
    { href: '/admin/dashboard', role: 'admin', bg: 'gray', title: 'Admin Console', titleHi: 'एडमिन कंसोल', desc: 'User verification, dispute resolution' },
];

// Authenticated Portal Selection (after login)
function PortalSelection() {
    const { user, logout } = useAuth();

    // Filter portals based on user role (admin sees all, others see their portal)
    const visiblePortals = user?.role === 'admin'
        ? portals
        : portals.filter(p => p.role === user?.role || p.role === 'admin');

    const handleLogout = () => {
        logout();
        window.location.href = '/login';
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-emerald-100 to-teal-200 dark:from-gray-900 dark:to-emerald-950 p-6 page-transition">
            <div className="max-w-2xl mx-auto">
                {/* User Info Header */}
                <div className="bg-white dark:bg-gray-800 rounded-2xl p-4 mb-6 shadow-lg flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <div className="w-12 h-12 rounded-full bg-emerald-100 dark:bg-emerald-900/30 flex items-center justify-center">
                            {portalIcons[user?.role || 'farmer']}
                        </div>
                        <div>
                            <p className="font-bold text-gray-800 dark:text-white">{user?.name}</p>
                            <p className="text-xs text-gray-500">{user?.mobile} • {user?.role?.toUpperCase()}</p>
                        </div>
                    </div>
                    <button
                        onClick={handleLogout}
                        aria-label="Logout"
                        className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors"
                    >
                        <LogOut size={20} className="text-gray-500" />
                    </button>
                </div>

                {/* Official Logo & branding */}
                <div className="text-center mb-10">
                    <div className="flex justify-center mb-4 scale-125">
                        <Logo size="xl" />
                    </div>
                    <h1 className="text-4xl font-black text-gray-900 dark:text-white tracking-tighter mb-2">
                        ANNADATA <span className="text-emerald-600">AI</span>
                    </h1>
                    <p className="text-emerald-600 dark:text-emerald-400 font-hindi text-lg font-medium">
                        अन्नदाता AI - भविष्य की खेती
                    </p>
                    <div className="h-1 w-20 bg-emerald-500 mx-auto mt-4 rounded-full"></div>
                </div>

                {/* Portal Selection */}
                <div className="space-y-4">
                    <div className="flex items-center justify-between mb-2">
                        <h2 className="text-sm font-bold text-gray-500 dark:text-gray-400 uppercase tracking-widest">
                            {user?.role === 'admin' ? 'All Portals' : 'Your Portal'}
                        </h2>
                        <span className="text-[10px] bg-emerald-500 text-white px-2 py-0.5 rounded-full font-bold">LATTICE 3.0</span>
                    </div>

                    <div className="grid gap-4">
                        {visiblePortals.map((portal, index) => (
                            <Link
                                key={index}
                                to={portal.href}
                                className="group block relative overflow-hidden bg-white dark:bg-gray-800 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-[1.02] border border-white dark:border-gray-700"
                            >
                                <div className={`absolute top-0 left-0 w-2 h-full bg-${portal.bg}-500 opacity-80`}></div>
                                <div className="p-5 flex items-center gap-5">
                                    <div className={`p-4 rounded-2xl bg-${portal.bg}-50 dark:bg-${portal.bg}-900/40 group-hover:scale-110 transition-transform flex items-center justify-center`}>
                                        {portalIcons[portal.role]}
                                    </div>
                                    <div className="flex-1">
                                        <div className="flex items-center gap-2">
                                            <h3 className="text-lg font-bold text-gray-800 dark:text-gray-100">{portal.title}</h3>
                                            <span className="text-[10px] text-gray-400 group-hover:text-emerald-500 transition-colors">LIVE</span>
                                        </div>
                                        <p className="text-xs text-emerald-600 dark:text-emerald-400 font-hindi mb-1">{portal.titleHi}</p>
                                        <p className="text-[11px] text-gray-500 dark:text-gray-400 leading-tight">{portal.desc}</p>
                                    </div>
                                    <div className="text-gray-300 dark:text-gray-600 group-hover:text-emerald-500 transition-colors">
                                        <ArrowLeft className="rotate-180" size={24} />
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>

                {/* System Stats */}
                <div className="mt-12 grid grid-cols-3 gap-4 text-center">
                    <div className="p-3">
                        <p className="text-xl font-bold text-gray-800 dark:text-white">14</p>
                        <p className="text-[10px] text-gray-500 uppercase font-bold tracking-tighter">Phases</p>
                    </div>
                    <div className="p-3 border-x border-gray-200 dark:border-gray-700">
                        <p className="text-xl font-bold text-gray-800 dark:text-white">Lattice</p>
                        <p className="text-[10px] text-gray-500 uppercase font-bold tracking-tighter">AI Engine</p>
                    </div>
                    <div className="p-3">
                        <p className="text-xl font-bold text-gray-800 dark:text-white">50M+</p>
                        <p className="text-[10px] text-gray-500 uppercase font-bold tracking-tighter">Target Farmers</p>
                    </div>
                </div>

                {/* Footer */}
                <div className="mt-8 text-center border-t border-gray-100 dark:border-gray-800 pt-6">
                    <p className="text-[10px] text-gray-400 uppercase tracking-widest font-bold mb-1">
                        ANNADATA AI Ecosystem
                    </p>
                    <p className="text-[9px] text-gray-400">
                        Powered by Lattice AI Engine & Secure Cloud Backbone
                    </p>
                    <p className="text-[8px] text-gray-300 mt-2">
                        Designed & Developed by Lattice Consulting Worldwide (OPC) Private Limited
                    </p>
                </div>
            </div>
        </div>
    );
}

// Auto-redirect based on auth state
function HomeRedirect() {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
        return <PageLoader />;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    // If authenticated but at root, redirect to portal selection
    return <PortalSelection />;
}

// ============= LAZY ROUTE WRAPPER =============
const LazyRoute = ({ children }: { children: React.ReactNode }) => (
    <Suspense fallback={<PageLoader />}>
        <div className="page-transition min-h-screen">
            {children}
        </div>
    </Suspense>
);

function App() {
    return (
        <IrrigationProvider>
            <CartProvider>
                <div className="app min-h-screen bg-gray-50 dark:bg-gray-900">
                    <Routes>
                        {/* Splash Screen - Eagerly loaded */}
                        <Route path="/splash" element={<SplashScreen />} />

                        {/* Onboarding Intro - Eagerly loaded */}
                        <Route path="/onboarding" element={<OnboardingScreen />} />

                        {/* Commodity Insight - AI Driven Market Co-pilot */}
                        <Route path="/farmer/commodity-insight" element={<LazyRoute><CommodityInsightPage /></LazyRoute>} />
                        <Route path="/farmer/upgrade-advisor" element={<LazyRoute><SmartFarmUpgradePage /></LazyRoute>} />

                        {/* Success Screen */}
                        <Route path="/success" element={<SuccessScreen />} />

                        {/* Auth Routes - Eagerly loaded for fast login */}
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/register" element={<RegisterPage />} />
                        <Route path="/select-role" element={<RoleSelectionPage />} />
                        <Route path="/profile-setup" element={<ProfileSetupPage />} />

                        {/* Home - Auto-redirect to splash on first visit */}
                        <Route path="/" element={<SplashScreen />} />

                        {/* ============= FARMER PORTAL (Lazy Loaded) ============= */}
                        <Route path="/farmer/dashboard" element={<LazyRoute><FarmerDashboardOverview /></LazyRoute>} />
                        <Route path="/farmer/soil-health" element={<LazyRoute><SoilHealthPage /></LazyRoute>} />
                        <Route path="/farmer/soil-test" element={<LazyRoute><SoilTestRegistration /></LazyRoute>} />
                        <Route path="/farmer/land-preparation" element={<LazyRoute><LandPreparationChecklist /></LazyRoute>} />
                        <Route path="/farmer/irrigation" element={<LazyRoute><IrrigationPage /></LazyRoute>} />
                        <Route path="/farmer/growth" element={<LazyRoute><GrowthTrackingPage /></LazyRoute>} />
                        <Route path="/farmer/harvest" element={<LazyRoute><HarvestPage /></LazyRoute>} />
                        <Route path="/farmer/market" element={<LazyRoute><MarketPricePage /></LazyRoute>} />
                        <Route path="/farmer/scan" element={<LazyRoute><CropScanPage /></LazyRoute>} />
                        <Route path="/farmer/weather" element={<LazyRoute><WeatherPage /></LazyRoute>} />
                        <Route path="/farmer/profile" element={<LazyRoute><ProfilePage /></LazyRoute>} />
                        <Route path="/farmer/seed-recommendation" element={<LazyRoute><SeedRecommendationWizard /></LazyRoute>} />
                        <Route path="/farmer/seeds" element={<LazyRoute><SeedMarketplacePage /></LazyRoute>} />
                        <Route path="/farmer/fertilizers" element={<LazyRoute><FertilizerMarketplacePage /></LazyRoute>} />
                        <Route path="/farmer/pesticides" element={<LazyRoute><PesticideMarketplacePage /></LazyRoute>} />
                        <Route path="/farmer/precision-yield" element={<LazyRoute><PrecisionYieldPortal /></LazyRoute>} />
                        <Route path="/farmer/schemes" element={<LazyRoute><GovernmentSchemesPage /></LazyRoute>} />
                        <Route path="/farmer/sensors" element={<LazyRoute><SensorDashboardPage /></LazyRoute>} />
                        <Route path="/farmer/irrigation-dashboard" element={<LazyRoute><IrrigationDashboardPage /></LazyRoute>} />
                        <Route path="/farmer/plant-health" element={<LazyRoute><PlantHealthPage /></LazyRoute>} />
                        <Route path="/farmer/growth-dashboard" element={<LazyRoute><GrowthDashboardPage /></LazyRoute>} />
                        <Route path="/farmer/harvest-planner" element={<LazyRoute><HarvestPlannerPage /></LazyRoute>} />
                        <Route path="/farmer/transport" element={<LazyRoute><TransportPage /></LazyRoute>} />
                        <Route path="/farmer/market-intelligence" element={<LazyRoute><MarketIntelligencePage /></LazyRoute>} />
                        <Route path="/farmer/irrigation-reminders" element={<LazyRoute><IrrigationReminderPage /></LazyRoute>} />
                        <Route path="/farmer/quality-grading" element={<LazyRoute><QualityGradingPage /></LazyRoute>} />
                        <Route path="/farmer/green-income" element={<LazyRoute><GreenIncomePage /></LazyRoute>} />
                        <Route path="/farmer/sell-strategy" element={<LazyRoute><SellStrategyPage /></LazyRoute>} />
                        <Route path="/farmer/agricarbon-hub" element={<LazyRoute><AgriCarbonHubPage /></LazyRoute>} />
                        <Route path="/farmer/biowaste" element={<LazyRoute><BiowastePage /></LazyRoute>} />
                        <Route path="/farmer/equipment" element={<LazyRoute><EquipmentMarketplacePage /></LazyRoute>} />
                        <Route path="/farmer/checkout" element={<LazyRoute><CheckoutPage /></LazyRoute>} />
                        <Route path="/farmer/iot" element={<LazyRoute><IotDashboardPage /></LazyRoute>} />
                        <Route path="/farmer/drone" element={<LazyRoute><DroneDashboardPage /></LazyRoute>} />
                        <Route path="/farmer/subsidy" element={<LazyRoute><SubsidyDiscoveryPage /></LazyRoute>} />
                        <Route path="/farmer/recommend" element={<LazyRoute><EquipmentRecommendationPage /></LazyRoute>} />
                        <Route path="/farmer/services" element={<LazyRoute><ServiceBookingPage /></LazyRoute>} />
                        <Route path="/farmer/ai-chat" element={<LazyRoute><AIChatPage /></LazyRoute>} />
                        <Route path="/farmer/ai-advisory" element={<LazyRoute><AiAdvisoryPage /></LazyRoute>} />
                        <Route path="/farmer/carbon-credits" element={<LazyRoute><CarbonCreditsPage /></LazyRoute>} />
                        <Route path="/farmer/3d-map" element={<LazyRoute><Cesium3DMapPage /></LazyRoute>} />
                        <Route path="/farmer/plant-growth" element={<LazyRoute><PlantGrowthPage /></LazyRoute>} />
                        <Route path="/farmer/debt-management" element={<LazyRoute><DebtManagementPage /></LazyRoute>} />
                        <Route path="/farmer/consortium" element={<LazyRoute><ConsortiumPage /></LazyRoute>} />
                        <Route path="/farmer/climate-resilience" element={<LazyRoute><ClimateResiliencePage /></LazyRoute>} />
                        <Route path="/farmer/export-readiness" element={<LazyRoute><ExportReadinessPage /></LazyRoute>} />
                        <Route path="/farmer/scheme-navigator" element={<LazyRoute><SchemeNavigatorPage /></LazyRoute>} />
                        <Route path="/farmer/smart-contracts" element={<LazyRoute><SmartContractsPage /></LazyRoute>} />
                        <Route path="/farmer/equipment-rental" element={<LazyRoute><EquipmentRentalPage /></LazyRoute>} />
                        <Route path="/farmer/girdawari" element={<LazyRoute><GirdawariPage /></LazyRoute>} />
                        <Route path="/farmer/land-records" element={<LazyRoute><LandRecordsPage /></LazyRoute>} />
                        <Route path="/farmer/storage-locator" element={<LazyRoute><StorageLocatorPage /></LazyRoute>} />
                        <Route path="/farmer/livestock" element={<LazyRoute><LivestockHubPage /></LazyRoute>} />
                        <Route path="/farmer/community" element={<LazyRoute><CommunityForumPage /></LazyRoute>} />
                        <Route path="/farmer/crop-diary" element={<LazyRoute><CropDiaryPage /></LazyRoute>} />
                        <Route path="/farmer/traceability" element={<LazyRoute><TraceabilityPage /></LazyRoute>} />
                        <Route path="/farmer/agri-calculator" element={<LazyRoute><AgriCalculatorPage /></LazyRoute>} />
                        <Route path="/farmer/mrv-dashboard" element={<LazyRoute><MRVDashboardPage /></LazyRoute>} />
                        <Route path="/farmer/plot-mapping" element={<LazyRoute><PlotMappingPage /></LazyRoute>} />
                        <Route path="/farmer/activity-log" element={<LazyRoute><ActivityLogPage /></LazyRoute>} />
                        <Route path="/farmer/carbon" element={<LazyRoute><CarbonCreditsPage /></LazyRoute>} />
                        <Route path="/farmer/carbon-wallet" element={<LazyRoute><CarbonWalletPage /></LazyRoute>} />
                        <Route path="/farmer/carbon-preview" element={<LazyRoute><CarbonPreviewPage /></LazyRoute>} />
                        <Route path="/farmer/carbon-marketplace" element={<LazyRoute><CarbonMarketplacePage /></LazyRoute>} />
                        <Route path="/farmer/baseline-assessment" element={<LazyRoute><BaselineAssessmentPage /></LazyRoute>} />
                        <Route path="/farmer/season-planner" element={<LazyRoute><SeasonPlannerPage /></LazyRoute>} />
                        <Route path="/farmer/prices" element={<LazyRoute><PriceDashboard /></LazyRoute>} />
                        <Route path="/farmer/demand-signals" element={<LazyRoute><DemandSignals /></LazyRoute>} />
                        <Route path="/farmer/opportunities" element={<LazyRoute><MarketOpportunities /></LazyRoute>} />
                        <Route path="/farmer/multi-crop-timer" element={<LazyRoute><MultiCropTimerPage /></LazyRoute>} />
                        <Route path="/farmer/digital-stall" element={<LazyRoute><DigitalStallPage /></LazyRoute>} />
                        <Route path="/farmer/order-success" element={<LazyRoute><OrderSuccessPage /></LazyRoute>} />
                        <Route path="/farmer/motor-control" element={<LazyRoute><MotorControlPage /></LazyRoute>} />
                        <Route path="/farmer/irrigation-marketplace" element={<LazyRoute><IrrigationMarketplacePage /></LazyRoute>} />
                        <Route path="/farmer/fuel-energy" element={<LazyRoute><FuelEnergyMarketplacePage /></LazyRoute>} />
                        <Route path="/farmer/processing-marketplace" element={<LazyRoute><ProcessingMarketplacePage /></LazyRoute>} />
                        <Route path="/farmer/tractor-hire" element={<LazyRoute><TractorHirePage /></LazyRoute>} />
                        <Route path="/farmer/banking-finance" element={<LazyRoute><BankingFinancePage /></LazyRoute>} />
                        <Route path="/farmer/export-global" element={<LazyRoute><GlobalMarketHubPage /></LazyRoute>} />
                        <Route path="/farmer/export-logistics" element={<LazyRoute><ExportLogisticsPage /></LazyRoute>} />
                        <Route path="/farmer/pricing" element={<LazyRoute><PricingPage /></LazyRoute>} />
                        <Route path="/farmer/buyer-matching" element={<LazyRoute><BuyerMatchingPage /></LazyRoute>} />

                        {/* ============= BUYER PORTAL (Lazy Loaded) ============= */}
                        <Route path="/buyer/dashboard" element={<LazyRoute><BuyerDashboardPage /></LazyRoute>} />
                        <Route path="/buyer/post-demand" element={<LazyRoute><PostDemand /></LazyRoute>} />
                        <Route path="/buyer/matches" element={<LazyRoute><FarmerMatches /></LazyRoute>} />
                        <Route path="/buyer/contracts" element={<LazyRoute><BuyerContractsPage /></LazyRoute>} />
                        <Route path="/buyer/orders" element={<LazyRoute><BuyerOrdersPage /></LazyRoute>} />
                        <Route path="/buyer/analytics" element={<LazyRoute><BuyerAnalyticsPage /></LazyRoute>} />
                        <Route path="/buyer/logistics" element={<LazyRoute><BuyerLogisticsPage /></LazyRoute>} />

                        {/* ============= TRANSPORTER PORTAL (Lazy Loaded) ============= */}
                        <Route path="/transporter/dashboard" element={<LazyRoute><TransporterDashboardPage /></LazyRoute>} />
                        <Route path="/transporter/book" element={<LazyRoute><TransportBooking /></LazyRoute>} />
                        <Route path="/transporter/tracking" element={<LazyRoute><ShipmentTracking /></LazyRoute>} />
                        <Route path="/transporter/earnings" element={<LazyRoute><TransporterEarningsPage /></LazyRoute>} />
                        <Route path="/transporter/fleet" element={<LazyRoute><FleetManagementPage /></LazyRoute>} />
                        <Route path="/transporter/routes" element={<LazyRoute><RouteOptimizationPage /></LazyRoute>} />
                        <Route path="/transporter/fuel" element={<LazyRoute><FuelTrackingPage /></LazyRoute>} />
                        <Route path="/transporter/documents" element={<LazyRoute><TransporterDocumentsPage /></LazyRoute>} />

                        {/* ============= GOVERNMENT PORTAL (Lazy Loaded) ============= */}
                        <Route path="/government/dashboard" element={<LazyRoute><GovernmentDashboardPage /></LazyRoute>} />
                        <Route path="/government/production" element={<LazyRoute><ProductionHeatmap /></LazyRoute>} />
                        <Route path="/government/supply-demand" element={<LazyRoute><SupplyDemandGap /></LazyRoute>} />
                        <Route path="/government/subsidies" element={<LazyRoute><SubsidyManagementPage /></LazyRoute>} />
                        <Route path="/government/schemes" element={<LazyRoute><SubsidyManagementPage /></LazyRoute>} />
                        <Route path="/government/farmers" element={<LazyRoute><FarmerRegistryPage /></LazyRoute>} />
                        <Route path="/government/carbon-verification" element={<LazyRoute><CarbonVerificationDashboard /></LazyRoute>} />
                        <Route path="/government/townhall" element={<LazyRoute><TownhallPage /></LazyRoute>} />
                        <Route path="/government/leaderboard" element={<LazyRoute><DistrictLeaderboard /></LazyRoute>} />
                        <Route path="/government/carbon-projects" element={<LazyRoute><CarbonProjectsPage /></LazyRoute>} />

                        {/* ============= SUPPLIER PORTAL (Lazy Loaded) ============= */}
                        <Route path="/supplier/dashboard" element={<LazyRoute><SupplierDashboard /></LazyRoute>} />
                        <Route path="/supplier/products/add" element={<LazyRoute><ProductUploadPage /></LazyRoute>} />
                        <Route path="/supplier/orders" element={<LazyRoute><SupplierOrdersPage /></LazyRoute>} />
                        <Route path="/supplier/inventory" element={<LazyRoute><SupplierInventoryPage /></LazyRoute>} />
                        <Route path="/supplier/payments" element={<LazyRoute><SupplierPaymentsPage /></LazyRoute>} />
                        <Route path="/supplier/analytics" element={<LazyRoute><SupplierAnalyticsPage /></LazyRoute>} />

                        {/* ============= ADMIN PORTAL (Lazy Loaded) ============= */}
                        <Route path="/admin/dashboard" element={<LazyRoute><AdminDashboardPage /></LazyRoute>} />
                        <Route path="/admin/users" element={<LazyRoute><UserManagementPage /></LazyRoute>} />
                        <Route path="/admin/roles" element={<LazyRoute><RolePermissionsPage /></LazyRoute>} />
                        <Route path="/admin/settings" element={<LazyRoute><SystemSettingsPage /></LazyRoute>} />
                        <Route path="/admin/monitoring" element={<LazyRoute><SystemMonitoringPage /></LazyRoute>} />
                        <Route path="/admin/audit" element={<LazyRoute><AuditLogsPage /></LazyRoute>} />

                        {/* ============= SHARED PAGES (Lazy Loaded) ============= */}
                        <Route path="/financial/analytics" element={<LazyRoute><FinancialAnalyticsPage /></LazyRoute>} />
                        <Route path="/notifications" element={<LazyRoute><NotificationsPage /></LazyRoute>} />
                        <Route path="/payment" element={<LazyRoute><PaymentPage /></LazyRoute>} />
                        <Route path="/expert-chat" element={<LazyRoute><ExpertChatPage /></LazyRoute>} />
                        <Route path="/knowledge/videos" element={<LazyRoute><VideoTutorialsPage /></LazyRoute>} />
                        <Route path="/legal" element={<LazyRoute><LegalPoliciesPage /></LazyRoute>} />
                        <Route path="/help" element={<LazyRoute><HelpSupportPage /></LazyRoute>} />
                        <Route path="/support" element={<LazyRoute><HelpSupportPage /></LazyRoute>} />

                        {/* Fallback */}
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>

                    {/* Floating AI Chat Widget - Global access */}
                    <Suspense fallback={null}>
                        <FloatingChatWidget excludePaths={['/login', '/register', '/splash', '/onboarding', '/']} />
                    </Suspense>
                </div>
            </CartProvider>
        </IrrigationProvider>
    );
}

export default App;
